import Components from "../../components";

const Favorites = ({ data, dataSetter }) => {
  return (
    <div>
      <Components.PageHeader
        id="page-header"
        label="Page Header"
        title="Favorilerim"
        safeArea={data?.system?.safeArea}
        pixelRatio={data?.system?.pixelRatio}
      />
      <Components.Favorites
        id="favorites"
        label="Favorites"
        data={data}
        dataSetter={dataSetter}
      />
    </div>
  );
};

export default Favorites;
